export default function ServiceArea() {
  const regions = [
    { name: 'Northeast', states: 'MA, NY, CT, RI, NH, VT, ME, NJ, PA' },
    { name: 'Southeast', states: 'FL, GA, NC, SC, VA, TN, AL, MS, LA' },
    { name: 'Midwest', states: 'IL, OH, MI, IN, WI, MN, IA, MO, KS' },
    { name: 'Southwest', states: 'TX, AZ, NM, OK, AR' },
    { name: 'West Coast', states: 'CA, OR, WA, NV, CO, UT' }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            <span className="text-[#C9A961]">Nationwide</span> Service Area
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We bring <strong>luxury custom tailoring</strong> directly to your home or office across all 50 states
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-12">
          {regions.map((region, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className="flex items-center space-x-3 mb-3">
                <div className="w-10 h-10 bg-[#C9A961]/10 rounded-full flex items-center justify-center">
                  <i className="ri-map-pin-line text-[#C9A961] text-xl"></i>
                </div>
                <h3 className="font-bold text-gray-900">{region.name}</h3>
              </div>
              <p className="text-sm text-gray-600">{region.states}</p>
            </div>
          ))}
        </div>

        {/* Map Visual */}
        <div className="bg-white rounded-2xl p-8 shadow-xl mb-12">
          <div className="relative">
            <img 
              src="https://www.britishtailors.com/wp-content/uploads/2016/08/house_calls_map.png"
              alt="Nationwide service coverage map"
              className="w-full h-auto rounded-lg"
            />
          </div>
        </div>

        {/* CTA */}
        <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            We Make House and Office Calls
          </h3>
          <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto">
            Our traveling consultants will be happy to come to your office or home anywhere in the country. 
            <strong className="text-white"> Call for appointment to schedule a visit.</strong>
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="#consultation" 
              className="inline-flex items-center justify-center bg-[#C9A961] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#B89851] transition-all duration-300 shadow-xl whitespace-nowrap"
            >
              <i className="ri-calendar-line mr-2"></i>
              Call for Appointment
            </a>
            <a 
              href="tel:866-857-8487" 
              className="inline-flex items-center justify-center bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 px-8 py-4 rounded-full font-semibold hover:bg-white/20 transition-all duration-300 whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              866-857-8487
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}